<lcs-loading-overlay [show]="appStartCallState | lcsCallState : 'loading'">
   <div class="login-wrapper">
      <form class="login-form" [formGroup]="form" (ngSubmit)="onSubmit()">
         <ndt-logo></ndt-logo>
         <h4 class="login-header">Sign in to your account</h4>
         @if (loginError) {
         <div class="login-error">
            <mat-error>
               {{ loginError }}
            </mat-error>
         </div>
         } @if (showLocalFields) {
         <div class="login-form-controls">
            <input
               id="b2907bc8-0a7e-44c9-a1a7-04d753879841"
               #username
               type="text"
               class="login-username"
               formControlName="username"
               placeholder="Username"
               aria-label="username"
            />
            <input
               id="3678cec4-7332-4e40-ba46-aba5abc73c85"
               #password
               type="password"
               class="login-password"
               formControlName="password"
               placeholder="Password"
               aria-label="password"
            />
         </div>
         <lcs-progress-button
            id="39257263-a4ce-4e91-a241-359076765374"
            [useCallState]="!samlSignInProgress ? loginCallState : ''"
            type="submit"
            >Continue</lcs-progress-button
         >
         } @if (hasSaml2Authentication && !showLocalFields) {
         <lcs-progress-button (click)="onSSO()" type="button" [useCallState]="samlSignInProgress ? loginCallState : ''"
            >Sign in with SSO</lcs-progress-button
         >
         }
         <!-- TODO: OAuth options -->
         <!-- <div class="login-or">or</div> -->
         <!-- <button type="button">(G) Sign in with Google</button> -->
      </form>
      @if (showLocalFields) {
      <div class="login-form-controls">
         @if (hasSaml2Authentication) {
         <a id="sso-login-link" class="sso-sign-in" href="javascript:void(0)" (click)="ssoUserSignIn()"
            >Sign in with SSO</a
         >
         }
         <a class="cant-sign-in" href="javascript:void(0)" (click)="onCannotSignInClick()">Can't sign in?</a>
      </div>
      } @if (!showLocalFields) {
      <a class="local-sign-in" id="local-login-link" href="javascript:void(0)" (click)="localSignIn()"
         >Sign in with Local User</a
      >
      } @if (isRelogin) {
      <button type="button" (click)="onCancelClick()" class="cancel-login">Cancel</button>
      }
   </div>
   @if (urlEnv !== 'com') {
   <div class="deploy-metadata-footer">
      @if (gitBranch) {
      <div class="metadata-item">
         <span class="metadata-label">Git Branch:</span>
         <span class="metadata-value">{{ gitBranch }}</span>
      </div>
      } @if (deployUser) {
      <div class="metadata-item">
         <span class="metadata-label">Deploy User:</span>
         <span class="metadata-value">{{ deployUser }}</span>
      </div>
      } @if (releaseName) {
      <div class="metadata-item">
         <span class="metadata-label">Release:</span>
         <span class="metadata-value">{{ releaseName }}</span>
      </div>
      } @if (extraNames?.length) {
      <div class="metadata-item">
         <span class="metadata-label">Extra Ingresses:</span>
         <span class="metadata-value">{{ extraNames.join(', ') }}</span>
      </div>
      } @if (gitCommit) {
      <div class="metadata-item">
         <span class="metadata-label">Git Commit:</span>
         <span class="metadata-value">{{ gitCommit }}</span>
      </div>
      } @if (deployTimestamp) {
      <div class="metadata-item">
         <span class="metadata-label">Deploy Timestamp:</span>
         <span class="metadata-value">{{ deployTimestamp }}</span>
      </div>
      } @if (enabledSkaffoldProfiles?.length) {
      <div class="metadata-item">
         <span class="metadata-label">Skaffold Profiles:</span>
         <span class="metadata-value">{{ enabledSkaffoldProfiles.join(', ') }}</span>
      </div>
      }
   </div>
   }
</lcs-loading-overlay>
